import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "tippy.js/dist/tippy.css";
import Browse_category_data from "../../data/Browse_category_data";
import Link from "next/link";
import Image from "next/image";
import { baseURL } from "../../pages/campaign/[campaignId]";

const Brand_campaign_carasoul = ({ allData }) => {
  return (
    <div className="overflow-hidden">
      <Swiper
        slidesPerView="auto"
        spaceBetween={10}
        loop={true}
        breakpoints={{
          // when window width is >= 640px
          100: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          // when window width is >= 768px
          700: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        }}
        className=" card-slider-4-columns !py-5"
        style={{ transform: "scaleX(1.2)" }}
      >
        {allData.length === 0 ? (
          // Render some fallback UI when allData is empty
          <SwiperSlide key={1}>
            <article>
              <Link
                href="/collection/explore_collection"
                className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg"
              >
                <figure
                  style={{ backgroundColor: "rgb(70 199 227)" }}
                  className={`relative rounded-t-[0.625rem] w-full rounded-[0.625rem pt-[65%]`}
                >
                  <Image
                    fill={true}
                    src="/images/categories/category_4.png"
                    alt="item 1"
                    className="w-full h-full object-fill"
                  />
                </figure>
                <div className="mt-4 text-center">
                  <span className="font-display text-jacarta-700 text-lg dark:text-white uppercase ">
                    No Campaign Present
                  </span>
                </div>
              </Link>
            </article>
          </SwiperSlide>
        ) : (
          allData.map((item) => {
            const { _id, overview } = item;
            const coverImageUrl = baseURL + overview.bannerImageUrl[0];
            return (
              <SwiperSlide key={_id}>
                <article>
                  <Link
                    href={"campaign/" + _id}
                    className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg"
                  >
                    <figure
                      style={{ backgroundColor: "rgb(70 199 227)" }}
                      className={`relative rounded-t-[0.625rem] w-full rounded-[0.625rem pt-[65%]`}
                    >
                      <Image
                        fill={true}
                        src={coverImageUrl}
                        alt="item 1"
                        className="w-full h-full object-fill"
                      />
                    </figure>
                    <div className="mt-4 text-center">
                      <span className="font-display text-jacarta-700 text-lg dark:text-accent uppercase">
                        {overview.campaignName}
                      </span>
                    </div>
                  </Link>
                </article>
              </SwiperSlide>
            );
          })
        )}
      </Swiper>
    </div>
  );
};

export default Brand_campaign_carasoul;
